// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"IZ-z","sponsoredTooltipWrapper":"JZ-z","sponsoredTooltip":"KZ-z","newCard":"LZ-z"};